import { render, staticRenderFns } from "./part.vue?vue&type=template&id=09723e05&scoped=true"
import script from "./part.vue?vue&type=script&lang=js"
export * from "./part.vue?vue&type=script&lang=js"
import style0 from "./assets/css/ys-page.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./part.vue?vue&type=style&index=1&id=09723e05&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09723e05",
  null
  
)

export default component.exports